module.exports = __webpack_public_path__ + "static/archer-3edcbbea5e6295a3c3a5bf820f93d043.jpeg";